import { render, staticRenderFns } from "./TourAIAssistant.vue?vue&type=template&id=67f7400e&scoped=true&"
import script from "./TourAIAssistant.vue?vue&type=script&lang=js&"
export * from "./TourAIAssistant.vue?vue&type=script&lang=js&"
import style0 from "./TourAIAssistant.vue?vue&type=style&index=0&id=67f7400e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f7400e",
  null
  
)

export default component.exports